import React, { Component } from 'react'
import { Map, TileLayer, Marker, LayersControl, ZoomControl } from 'react-leaflet'
import { latLngBounds } from 'leaflet'
import MarkerClusterGroup from 'react-leaflet-markercluster'
import 'react-leaflet-markercluster/dist/styles.min.css'
import { shopIcon, hoveredShopIcon } from '../resort/DestinationsMap'
import uniqBy from 'lodash/uniqBy'
import debounce from 'lodash/debounce'
import API from '../../api'
import MapPopup from './MapPopup'
import Loader from '../helpers/Loader'

let controller,
  signal
export default class SearchMap extends Component {
  constructor(props) {
    super(props)
    this.mapContainer = React.createRef()

    this.state = {
      pins: [],
      loading: true,
    }
    this.footer = document.getElementById('main-footer')
  }

  componentDidMount() {
    this.getPins()
    if(this.footer) {
      this.footer.style.display = 'none'
    }
  }

  componentDidUpdate(prevProps) {
    if(JSON.stringify(prevProps.selectedParams) !== JSON.stringify(this.props.selectedParams) ||
      prevProps.getNewData !== this.props.getNewData
    ) {
      this.setState({
        pins: [],
        loading: true,
      }, this.getPins)
    }
  }

  componentWillUnmount() {
    if(this.footer) {
      this.footer.style.display = ''
    }
  }

  getPins = () => {
    if(controller !== undefined) {
      // Cancel the previous request
      controller.abort()
    }

    if('AbortController' in window) {
      controller = new window.AbortController()
      signal = controller.signal
    }

    const currentBounds = this.mapContainer.current.leafletElement.getBounds()
    const bounds = {
      leftBound: `${currentBounds._southWest.lat},${currentBounds._southWest.lng}`,
      rightBound: `${currentBounds._northEast.lat},${currentBounds._northEast.lng}`,
    }

    if(this.props.onMapMove) {
      this.props.onMapMove([{
        lat: currentBounds._southWest.lat,
        lng: currentBounds._southWest.lng,
      }, {
        lat: currentBounds._northEast.lat,
        lng: currentBounds._northEast.lng,
      }])
    }

    return API(`search/resorts/geo/`, signal).get({
      ...bounds,
      ...this.props.selectedParams,
    }).then((data) => {
      let pins = uniqBy([...this.state.pins, ...data], 'shopId')
      this.setState({
        pins,
        loading: false,
      })
    }).catch((error) => {
      if(window.DOMException && error.code === window.DOMException.ABORT_ERR) {
        console.warn('Request canceled.')
      } else {
        this.setState({
          loading: false,
          numberOfTrips: 0,
          shops: [],
        })
      }
    })
  }

  selectShop(shop) {
    this.setState({
      shopId: shop.shopId,
    })
  }

  render() {
    const { locationCoordinates, selectedParams, totalGuests, isAllParamsSelected } = this.props
    const bounds = latLngBounds()

    locationCoordinates.forEach(coord => {
      bounds.extend([coord.lat, coord.lng])
    })
    return (
      <div className={`search-page-map-wrapper ${this.state.loading ? 'loading' : ''}`}>
        {this.state.loading ? (<Loader />) : ''}
        <div className='search-page-map'>
          { this.state.shopId ? (<MapPopup selectedParams={selectedParams} isAllParamsSelected={isAllParamsSelected} onPopupClose={() => this.selectShop(false)} shopId={this.state.shopId} totalGuests={totalGuests} />) : ''}
          <Map zoomControl={false} onMoveEnd={debounce(this.getPins, 300)} ref={this.mapContainer} bounds={bounds} style={{ height: '100%' }} maxZoom={18} >
            <LayersControl position='topright'>
              <LayersControl.BaseLayer name='PADI Travel map' checked>
                <TileLayer
                  url='https://api.mapbox.com/styles/v1/mapbox/light-v9/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiZGl2aWFjIiwiYSI6ImNiZjU5MGVlY2VkZmQ4YWFkNGJmMWVjMDVjMDUzNDdlIn0.62dEH0gmRXAGO5e2x1JnRg'
                />
              </LayersControl.BaseLayer>
              <LayersControl.BaseLayer name='Satellite'>
                <TileLayer
                  url='//server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
                />
              </LayersControl.BaseLayer>
            </LayersControl>
            <ZoomControl position='topright' />
            <MarkerClusterGroup>
              { this.state.pins.map((pin) => {
                return <Marker
                  onMouseOver={(e) => {
                    if(this.state.hoveredPin !== e.target.options.id) {
                      this.setState({
                        hoveredPin: e.target.options.id,
                      })
                    }
                  }}
                  onMouseOut={() => {
                    setTimeout(() => {
                      this.setState({ hoveredPin: null })
                    })
                  }}
                  key={pin.shopId}
                  id={pin.shopId}
                  position={[pin.latitude, pin.longitude]}
                  icon={this.state.hoveredPin === pin.shopId ? hoveredShopIcon : shopIcon}
                  onClick={() => this.selectShop(pin)} />
              }) }
            </MarkerClusterGroup>
          </Map>
        </div>
      </div>
    )
  }
}
